<template>
  <div>
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="table-action-box" v-bind="attrs" v-on="on">
        <v-icon small>mdi-bullhorn</v-icon>
        <span class="table-action-label">Campanhas</span>
      </div>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-bullhorn</v-icon>
        <div>
          <span class="sc-modal__title">Campanhas</span>
          <span class="sc-modal__subtitle">{{ (producao.nome_producao || producao.sig_producao) + ' · ' + producao.sig_producao }}</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <div class="campanha-insert">
          <v-text-field
            placeholder="Código da campanha"
            solo flat dense
            hide-details
            background-color="surface_tertiary"
            v-model="id_campanha"
            class="campanha-input"
          />
          <v-btn
            small
            color="primary"
            @click="inserirCampanha(producao.cod_producao, id_campanha)"
            class="campanha-insert-btn"
          >
            <v-icon small class="mr-1">mdi-plus</v-icon>
            Inserir
          </v-btn>
        </div>

        <div v-if="campanhas && campanhas.length > 0" class="campanha-list">
          <div
            v-for="item in campanhas"
            :key="item.cod_campanha"
            class="campanha-item"
          >
            <span class="campanha-code">{{ item.cod_campanha }}</span>
            <v-btn
              icon
              x-small
              class="campanha-remove-btn"
              @click="removerCampanha(producao.cod_producao, item.cod_campanha)"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        <div v-else class="campanha-empty">
          <span>Nenhuma campanha cadastrada</span>
        </div>
      </div>
    </v-card>
  </v-dialog>
  <ModalConfirmAction
    :visible="showConfirmDialog"
    title="Confirmar ação"
    :message="confirmMessage"
    confirm-text="Confirmar"
    confirm-color="red"
    @confirm="executeConfirmAction"
    @cancel="showConfirmDialog = false"
  />
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import ModalConfirmAction from "../ModalConfirmAction.vue";

export default {
  components: {
    ModalConfirmAction,
  },
  props: {
    producao: Object,
  },
  data() {
    return {
      dialog: false,
      campanhas: null,
      id_campanha: "",
      showConfirmDialog: false,
      confirmMessage: "",
      pendingConfirmAction: null,
    };
  },
  async mounted() {
    await this.getCampanhasProducao();
  },
  created() {},
  watch: {
    dialog(open) {
      if (open) this.id_campanha = "";
    },
  },
  methods: {
    async getCampanhasProducao() {
      await apiClient
        .get(`listaCampanhasProducao/${this.producao.cod_producao}`)
        .then((response) => {
          this.campanhas = response.data.campanhas;
        })
        .catch(() => {});
    },

    async inserirCampanha(cod_producao, cod_campanha) {
      if (cod_campanha.trim() === "") {
        this.$toast.error("Informe o id da campanha");
        return;
      }
      this.confirmMessage = "Tem certeza que quer adicionar essa campanha?";
      this.pendingConfirmAction = () => this.executarInserirCampanha(cod_producao, cod_campanha);
      this.showConfirmDialog = true;
    },
    async executarInserirCampanha(cod_producao, cod_campanha) {
      await apiClient
        .post("/inserirCampanhaProducao", {
          cod_producao,
          cod_campanha,
        })
        .then(async () => {
          this.$toast.success("Campanha inserida com sucesso");
          await this.getCampanhasProducao(cod_producao);
          this.id_campanha = "";
        })
        .catch((error) => {
          this.$toast.error(error.response.data.error);
        });
    },
    async removerCampanha(cod_producao, cod_campanha) {
      this.confirmMessage = "Tem certeza que deseja remover essa campanha?";
      this.pendingConfirmAction = () => this.executarRemoverCampanha(cod_producao, cod_campanha);
      this.showConfirmDialog = true;
    },
    async executarRemoverCampanha(cod_producao, cod_campanha) {
      await apiClient
        .delete(`removerCampanhaProducao/${cod_producao}/${cod_campanha}`)
        .then(async () => {
          this.$toast.success("Campanha removida com sucesso!");
          await this.getCampanhasProducao();
        })
        .catch(() => {
          this.$toast.error("Não foi possível remover a campanha.");
        });
    },
    async executeConfirmAction() {
      this.showConfirmDialog = false;
      if (this.pendingConfirmAction) {
        await this.pendingConfirmAction();
        this.pendingConfirmAction = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Campanhas-specific: blue hover override on top of the global .table-action-box.
.table-action-box:hover {
  border-color: var(--sc-color-edit);
  background: rgba(var(--sc-color-edit-rgb), 0.08);
  .v-icon { color: var(--sc-color-edit) !important; }
}

.campanha-insert {
  display: flex; align-items: center; gap: 8px; margin-bottom: 16px;
}
.campanha-input { flex: 1; }
.campanha-insert-btn {
  text-transform: none !important; letter-spacing: 0 !important;
  font-weight: var(--sc-weight-semi) !important; border-radius: var(--sc-radius-md) !important;
  flex-shrink: 0;
}

.campanha-list {
  display: flex; flex-direction: column; gap: 4px;
}
.campanha-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 14px;
  background: var(--sc-surface-tint-subtle); border-radius: var(--sc-radius-md);
  transition: background var(--sc-duration-fast) var(--sc-easing-standard);
  &:hover { background: var(--sc-surface-tint-hover); }
}
.campanha-code {
  font-size: var(--sc-text-base); font-weight: var(--sc-weight-medium);
  color: var(--v-text_primary-base); font-family: monospace;
}
.campanha-remove-btn {
  &:hover { background: rgba(var(--sc-color-error-rgb), 0.15) !important; }
}

.campanha-empty {
  text-align: center; padding: 24px;
  font-size: var(--sc-text-base); color: var(--v-text_secondary-base);
}
</style>
